export default "__VITE_ASSET__BXyjb8FI__"